export default __webpack_public_path__ + "maps-examples-tracking-mode-thumbnail-960-d7c5adb0555890ef19d364afad7dbdfe.png";